<template>
  <form
    v-if="isInterview"
    id="futuro-customer-value"
    class="my-5"
    @submit.prevent
  >
    <div class="card">
      <div class="row align-items-center justify-content-between">
        <div class="card-title col-auto mb-3">
          <img
            v-if="!monthlyAverage"
            src="~@/assets/img/chevron-down-solid.svg"
            alt="Futuro | Consultoria Financeira"
            @click="monthlyAverage = !monthlyAverage"
          />
          <img
            v-if="monthlyAverage"
            src="~@/assets/img/chevron-up-solid.svg"
            alt="Futuro | Consultoria Financeira"
            @click="monthlyAverage = !monthlyAverage"
          />
          <h2>Investimento</h2>
        </div>
        <spinner v-if="loading" class="mr-2" />
      </div>
      <div v-if="monthlyAverage">
        <div class="row mt-3 mb-3 px-3">
          <div class="col-12 blue-card totalizer annual-income-card">
            <span>Renda bruta anual:</span>
            <span>{{ formatCurrency(annualGross, "BRL") }}</span>
          </div>
        </div>
        <div class="row justify-content-center mt-3 mb-3">
          <div class="col-auto blue-card monthly-value monthly-value-card">
            <div class="value-primary">
              <span class="label-text">{{ paymentLabel }}</span>
              <span class="value-text">{{ formatCurrency(headlineValue, "BRL") }}</span>
            </div>
            <div
              v-if="showDetails"
              class="value-details"
            >
              <template v-if="maxParcelAmount > 0">
                Mensal <b>{{ formatCurrency(maxParcelAmount, "BRL") }}</b>
                do projeto
              </template>
              <template v-if="!isOnlyConsulting && subscriptionAmount > 0">
                <template v-if="maxParcelAmount > 0"> + </template>
                <b>{{ formatCurrency(subscriptionAmount, "BRL") }}</b>
                da assinatura
              </template>
            </div>
            <div
              v-if="showProjectTotal"
              class="value-total"
            >
              Total do Projeto: <b>{{ formatCurrency(maxParcelTotalAmount, "BRL") }}</b>
            </div>
          </div>
        </div>
        <div
          v-if="!isOnlyConsulting && subscriptionAmount > 0"
          class="row justify-content-center mt-3 mb-3"
        >
          <p class="col-auto">
            À partir do segundo ano:
            <b>{{ formatCurrency(subscriptionAmount, "BRL") }}</b>
            + projeto (dependendo da sua necessidade)
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import * as types from "../store/types";
import * as sharedTypes from "@/modules/shared/store/types";
import Spinner from "../../shared/components/Spinner";
export default {
  components: {
    Spinner,
  },
  props: {
    interviewSection: {
      type: String,
      default: "",
    },
    isInterview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      monthlyAverage: false,
    };
  },
  computed: {
    ...mapGetters({
      calculation: types.PROPOSAL_CALCULATION,
      proposal: types.PROPOSAL,
      loading: types.LOADING_CALCULATION_PER_MONTH,
      formatCurrency: types.FORMAT_CURRENCY,
    }),
    isOnlyConsulting() {
      return this.proposal?.services_to_contract === 'only_consulting';
    },
    isOnlySubscription() {
      return this.proposal?.services_to_contract === 'only_subscription';
    },
    annualGross: function() {
      return this.calculation ? this.calculation.annual_gross : 0;
    },
    subscriptionAmount: function() {
      return this.calculation ? Number(this.calculation.subscription_amount) || 0 : 0;
    },
    maxParcelAmount: function() {
      if (this.isOnlySubscription) return 0;
      return this.calculation ? Number(this.calculation.max_parcel_amount) || 0 : 0;
    },
    maxParcelTotalAmount: function() {
      if (this.isOnlySubscription) return 0;
      return this.calculation ? Number(this.calculation.max_parcel_total_amount) || 0 : 0;
    },
    paymentLabel: function() {
      return this.isOnlySubscription ? "Mensal" : "Mensal (12x)";
    },
    headlineValue: function() {
      if (this.isOnlySubscription) return this.subscriptionAmount;
      if (this.isOnlyConsulting) return this.maxParcelAmount;
      return this.maxParcelAmount + this.subscriptionAmount;
    },
    showDetails: function() {
      if (this.isOnlySubscription) return false;
      return this.maxParcelAmount > 0 || this.subscriptionAmount > 0;
    },
    showProjectTotal: function() {
      return !this.isOnlySubscription && this.maxParcelTotalAmount > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 16px;
  margin: 0;
  b {
    font-weight: 600;
  }
}
.blue-card {
  &.totalizer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px 20px;
    &.annual-income-card {
      background-color: rgba(24, 29, 47, 0.7) !important;
    }
  }
  &.monthly-value {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 500px;
    min-height: 300px;
    padding: 40px 55px;
    &.monthly-value-card {
      background-color: rgba(24, 29, 47, 0.7) !important;
    }

    .value-primary {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 10px;

      .label-text {
        font-size: 18px;
        font-weight: 400;
        color: #fff;
        margin-bottom: 5px;
      }

      .value-text {
        font-size: 48px;
        font-weight: 700;
        color: #fff;
        line-height: 1.2;
      }
    }

    .value-details {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.85);
      text-align: center;
      line-height: 1.5;
      
      b {
        font-weight: 600;
        color: #fff;
      }
    }

    .value-total {
      font-size: 22px;
      font-weight: 500;
      color: #ffeb98;
      text-align: center;
      margin-top: 10px;
      
      b {
        font-weight: 700;
      }
    }
  }
}
</style>
